module.exports = __webpack_public_path__ + "img/d3006e1093494f35867afdcd8df5ad82.5ca9508c.jpg";